export const TOAST_TIMEOUT_MEDIUM_MS = 4000;
export const TOAST_TIMEOUT_LARGE_MS = 6000;

export const TOAST_TIMEOUT_VARIANTS = ["medium", "large"] as const;
